import React from "react";
import { Box } from "@chakra-ui/react";

export function ManagerIcon() {
  return (
    <Box as="svg" xmlns="http://www.w3.org/2000/svg" boxSize="icon.xl" viewBox="0 0 32 32" fill="none">
      <Box
        as="path"
        fill="new.blue.900"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 7.99984C18.9456 7.99984 21.3333 10.3877 21.3333 13.3332C21.3333 16.2787 18.9455 18.6665 16 18.6665C13.0544 18.6665 10.6666 16.2787 10.6666 13.3332C10.6666 10.3877 13.0544 7.99984 16 7.99984ZM16 10.6665C14.5272 10.6665 13.3333 11.8604 13.3333 13.3332C13.3333 14.806 14.5271 15.9998 16 15.9998C17.4728 15.9998 18.6666 14.806 18.6666 13.3332C18.6666 11.8604 17.4728 10.6665 16 10.6665Z"
      />
      <Box
        as="path"
        fill="new.blue.900"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 2.6665C23.3638 2.6665 29.3333 8.63605 29.3333 15.9998C29.3333 20.0312 27.5423 23.6455 24.7174 26.0884C22.3806 28.1091 19.3316 29.3332 16 29.3332C12.6683 29.3332 9.61922 28.1091 7.28251 26.0884C4.45764 23.6455 2.66663 20.0312 2.66663 15.9998C2.66663 8.63604 8.63617 2.6665 16 2.6665ZM16 22.6665C13.6125 22.6665 11.6048 23.5153 10.1198 24.8996C11.8057 26.0161 13.8255 26.6665 16 26.6665C18.1746 26.6665 20.1941 26.015 21.8802 24.8983C20.3952 23.5144 18.3871 22.6665 16 22.6665ZM16 5.33317C10.1089 5.33317 5.33329 10.1088 5.33329 15.9998C5.33329 18.7531 6.37718 21.2601 8.0911 23.1535C10.0833 21.194 12.8169 19.9998 16 19.9998C19.1827 19.9998 21.9154 21.1944 23.9075 23.1535C25.6218 21.2601 26.6666 18.7534 26.6666 15.9998C26.6666 10.1088 21.891 5.33317 16 5.33317Z"
      />
    </Box>
  );
}
